import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia, PiniaVuePlugin } from 'pinia';
import i18n from './TUIRoom/locales/';
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.prototype.$store = store
Vue.use(ElementUI);
Vue.use(i18n);

Vue.config.productionTip = false;

new Vue({
  pinia,
  // @ts-ignore
  store,
  router,
  render: h => h(App),
}).$mount('#app');
